import React from 'react';
import { Box, Typography } from '@material-ui/core';

interface IFactProps {
  label: string;
  value?: string | null;
}

// One <dt>/<dd> pair rendered as a compact grid cell. Suppressed when the
// value is empty so the header stays tight on incomplete player records.
export const Fact: React.FC<IFactProps> = ({ label, value }) => {
  if (!value) return null;
  return (
    <Box style={{ minWidth: 0 }}>
      <Typography
        component="dt"
        variant="caption"
        color="textSecondary"
        style={{ textTransform: 'uppercase', letterSpacing: 0.4 }}
      >
        {label}
      </Typography>
      <Typography
        component="dd"
        variant="body2"
        style={{ margin: 0, fontWeight: 500, overflowWrap: 'anywhere' }}
      >
        {value}
      </Typography>
    </Box>
  );
};
